
import { articleStyles } from './articleStyles';
import DOMPurify from 'dompurify';

interface ArticleContentProps {
  content: string;
}

export default function ArticleContent({ content }: ArticleContentProps) {
  // SECURITY: Sanitize HTML content to prevent XSS attacks
  const sanitizedContent = DOMPurify.sanitize(content, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'blockquote', 'a', 'img'],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target'],
    ALLOW_DATA_ATTR: false
  });

  return (
    <div className="prose prose-invert prose-lg max-w-none article-content">
      <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
      <style>{articleStyles}</style>
    </div>
  );
}
